module.exports = {"id":"214158","name":"Yeison Gordillo","rating":"74","photo":"./data/images/photos/4/214158.png","club":{"name":"Ind. Santa Fe","logo":"./data/images/clubs/Ind.SantaFe.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YeisonGordillo0.json
// module id = 4402
// module chunks = 0